//@flow
export type LogoPaymentMethodCategory =
  | 'bank'
  | 'cash_on_delivery'
  | 'digital_wallet'
  | 'others';
export type LogoPaymentMethod = {
  label: string,
  value: string,
  logoId?: string,
  category: LogoPaymentMethodCategory,
  country?: string,
  localPreview?: string,
};

type DocumentType = {
  label: string,
  value: string,
};

type PaymentMethodsByCurrency = {
  [key: string]: string[],
};

const BANKS: LogoPaymentMethod[] = [
  {
    label: 'Transferencia bancaria - Banco BBVA',
    value: 'bbva',
    logoId: 'FL-4E728ED3',
    category: 'bank',
    country: 'PE',
  },
  {
    label: 'Transferencia bancaria - Banco Banbif',
    value: 'banbif',
    logoId: 'FL-47B98D2D',
    category: 'bank',
    country: 'PE',
  },
  {
    label: 'Transferencia bancaria - Banco BCP',
    value: 'bcp',
    logoId: 'FL-45E3AB88',
    category: 'bank',
    country: 'PE',
  },
  {
    label: 'Transferencia bancaria - Banco Comercio',
    value: 'banco-comercio',
    logoId: 'FL-4B3257ED',
    category: 'bank',
    country: 'PE',
  },
  {
    label: 'Transferencia bancaria - Banco Pichincha',
    value: 'banco-pichincha',
    logoId: 'FL-426D9529',
    category: 'bank',
    country: 'PE',
  },
  {
    label: 'Transferencia bancaria - Banco GNB',
    value: 'bancognb',
    logoId: 'FL-49E8D2A9',
    category: 'bank',
    country: 'PE',
  },
  {
    label: 'Transferencia bancaria - Banco Interbank',
    value: 'interbank',
    logoId: 'FL-46526E73',
    category: 'bank',
    country: 'PE',
  },
  {
    label: 'Transferencia bancaria - Banco Scotiabank',
    value: 'scotiabank',
    logoId: 'FL-4D3E6D73',
    category: 'bank',
    country: 'PE',
  },
];

const CASH_ON_DELIVERY: LogoPaymentMethod = {
  label: 'Pago contra entrega',
  value: 'cash-on-delivery',
  logoId: 'FL-4A3AED66',
  category: 'cash_on_delivery',
};

const DIGITAL_WALLETS: LogoPaymentMethod[] = [
  {
    label: 'Yape',
    value: 'yape',
    logoId: 'FL-4B325D9D',
    category: 'digital_wallet',
    country: 'PE',
  },
  {
    label: 'Lukita',
    value: 'lukita',
    logoId: 'FL-489BDA63',
    category: 'digital_wallet',
    country: 'PE',
  },
  {
    label: 'Plin',
    value: 'plin',
    logoId: 'FL-4328B678',
    category: 'digital_wallet',
    country: 'PE',
  },
  {
    label: 'Tunki',
    value: 'tunki',
    logoId: 'FL-47B9857D',
    category: 'digital_wallet',
    country: 'PE',
  },
];

export const LOGO_PAYMENT_METHODS: LogoPaymentMethod[] = [
  ...BANKS,
  CASH_ON_DELIVERY,
  ...DIGITAL_WALLETS,
];

export const DOCUMENT_TYPES: DocumentType[] = [
  {
    label: 'Documento de Identidad',
    value: 'dni',
  },
  {
    label: 'Cédula de Identidad',
    value: 'ci',
  },
  {
    label: 'Pasaporte',
    value: 'passport',
  },
  {
    label: 'RUC',
    value: 'ruc',
  },
];

export const ADD_NEW_BANK = {
  label: '+ Añadir Otro',
  value: 'addNewBank',
};

export const STORE_SUPPORTED_CURRENCY_CODES = [
  'PEN',
  'COP',
  'USD',
  'MXN',
  'CLP',
  'BOB',
  'ARS',
  'PYG',
  'UYU',
  'PAB',
  'CRC',
  'GTQ',
  'VES',
  'HNL',
  'NIO',
  'EUR',
  'DOP',
];

export const PAYPAL_SUPPORTED_CURRENCY_CODES = ['USD', 'MXN', 'EUR'];

export const STRIPE_SUPPORTED_CURRENCY_CODES = [
  'PEN',
  'COP',
  'USD',
  'MXN',
  'CLP',
  'BOB',
  'ARS',
  'PYG',
  'UYU',
  'PAB',
  'CRC',
  'GTQ',
  'VES',
  'HNL',
  'NIO',
  'EUR',
  'DOP',
];
export const CULQI_SUPPORTED_CURRENCY_CODES = ['PEN'];

export const IZIPAY_SUPPORTED_CURRENCY_CODES = ['PEN', 'USD'];

export const TRANSBANK_SUPPORTED_CURRENCY_CODES = ['CLP', 'USD'];

export const MERCADO_PAGO_SUPPORTED_CURRENCY_CODES = [
  'ARS',
  'BOB',
  'CLP',
  'COP',
  'CRC',
  'DOP',
  'EUR',
  'GTQ',
  'HNL',
  'MXN',
  'NIO',
  'PAB',
  'PEN',
  'PYG',
  'USD',
  'UYU',
  'VES',
];

export const NIUBIZ_SUPPORTED_CURRENCY_CODES = ['PEN', 'USD'];

export const universalMethods = [
  'CONTINUE_TO_CHAT',
  'PAY_ON_DELIVERY',
  'OTHERS',
];

export const methodsByCurrency: PaymentMethodsByCurrency = {
  PAYPAL: PAYPAL_SUPPORTED_CURRENCY_CODES,
  STRIPE_CHECKOUT: STRIPE_SUPPORTED_CURRENCY_CODES,
  CULQI: CULQI_SUPPORTED_CURRENCY_CODES,
  IZIPAY: IZIPAY_SUPPORTED_CURRENCY_CODES,
  TRANSBANK: TRANSBANK_SUPPORTED_CURRENCY_CODES,
  MERCADOPAGO_CHECKOUT_PRO: MERCADO_PAGO_SUPPORTED_CURRENCY_CODES,
  NIUBIZ_WEB: NIUBIZ_SUPPORTED_CURRENCY_CODES,
  NIUBIZ_PAY_LINK: NIUBIZ_SUPPORTED_CURRENCY_CODES,
};
